import { Component, ElementRef, inject, OnDestroy } from '@angular/core';
import { AppMenuComponent } from './app.menu.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app.sidebar.component.html',
  standalone: true,
  imports: [AppMenuComponent],
})
export class AppSidebarComponent implements OnDestroy {
  public el = inject(ElementRef);
  constructor() {}
  ngOnDestroy(): void {}
}
